import VueSmoothScroll from 'vue3-smooth-scroll'
import PrimeVue from 'primevue/config'
import Aura from '@primevue/themes/aura'

export const modifyProvideApp = () => {
  return null
}

export const modifyApp = (app, router) => {
  app.use(VueSmoothScroll, {
    updateHistory: false
  })
  app.use(PrimeVue, {
    theme: {
      preset: Aura,
      options: {
        darkModeSelector: '.fake-dark-selector',
      }
    },
  });
}

